import { useTranslation } from 'react-i18next'
import { SectionCus, SystemCard } from '../components'

export const WhatWeDo = () => {
  const { t } = useTranslation()

  return (
    <div className="bg-right-top bg-no-repeat sm:bg-gradient-to-b from-altDarkNavy to-darkNavy bg-25-100">
      <SectionCus>
        <div className="flex flex-col md:flex-row">
          <div className="py-8 px-4 md:py-20 md:px-10 w-full lg:w-2/3 md:w-3/5">
            <p className="text-xl font-semibold text-azul my-3">{t('home.whatWeDo')}</p>
            <p className="text-5xl font-semibold mb-6 text-darkNavy">{t('home.aNewWayPlay')}</p>
            <p className="text-base text-darkNavy mb-12">
              &quot;{t('home.aNewWayPlayDesc')}&quot;
              <span className="font-semibold"> - Ben Johns</span>
            </p>
            <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-4">
              <SystemCard
                image="img/Logo.png"
                altImage="search"
                title={t('home.searchTheDatabase')}
                description={t('home.searchTheDatabaseDesc')}
              />
              <SystemCard
                image="img/Logo_5.png"
                altImage="clubs"
                title={t('home.findYourClub')}
                description={t('home.findYourClubDesc')}
              />
              <SystemCard
                image="img/Logo_2.png"
                altImage="analyze"
                title={t('home.analyzePerformance')}
                description={t('home.analyzePerformanceDesc')}
              />
              <SystemCard
                image="img/Logo_3.png"
                altImage="matches"
                title={t('home.logMatches')}
                description={t('home.logMatchesDesc')}
              />
              <SystemCard
                image="img/Logo_4.png"
                altImage="local players"
                title={t('home.connectLocalPlayers')}
                description={t('home.connectLocalPlayersDesc')}
              />
              <SystemCard
                image="img/Logo_6.png"
                altImage="events"
                title={t('home.events')}
                description={t('home.eventsDesc')}
              />
            </div>
          </div>
          <div className="px-10 md:pr-5 md:px-0 lg:px-10 w-full lg:w-1/3 md:w-2/5 order-first md:order-last bg-darkNavy sm:bg-transparent">
            <img
              src="img/Browse_Players.png"
              alt="browse players"
              className="w-full sm:w-56 md:w-80 lg:w-96 py-20 object-contain sm:mt-52 md:mt-36 lg:mt-20"
            />
          </div>
        </div>
      </SectionCus>
    </div>
  )
}
